var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.52 20.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.89,10.98c3.55-3.46,4-6.72,1.36-9.34-2.21-2.19-5.65-2.19-7.87,0-2.65,2.6-2.2,5.88,1.38,9.37-1.6,.75-2.74,1.73-3.49,2.93-.76-1.23-1.91-2.23-3.47-2.96,3.55-3.46,4-6.72,1.36-9.34-2.21-2.19-5.65-2.19-7.87,0C.64,4.24,1.08,7.51,4.66,11.01,1.4,12.53,.07,15.03,0,18.33c-.03,1.37,.48,2.08,1.98,2.05,3.49-.06,6.97-.06,10.46,0,.32,0,.58-.03,.81-.09,.23,.06,.5,.09,.82,.09,3.49-.06,6.97-.06,10.46,0,1.51,.03,2.01-.68,1.99-2.05-.05-3.38-1.53-5.87-4.63-7.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/communityIcon.cb24f15f2f51b2b8c714c3a480d45d90.svg";
export { ForwardRef as ReactComponent };